import { productQuantityBreakPricingStyles } from "@insite/content-library/Components/ProductQuantityBreakPricing";
import { SPACING, TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

const headingStyles = {
    alignX: "center",
    typographyProps: {
        size: TYPOGRAPHY.size.tiny,
    },
    css: css`
        height: 35px;
        background: none;
        padding: 6px;
    `,
};

Object.assign(productQuantityBreakPricingStyles, {
    viewLink: {
        typographyProps: {
            css: css`
                font-weight: ${TYPOGRAPHY.weight.bold};

                &:hover,
                &:focus {
                    text-decoration: underline;
                }
            `,
        },
    },
    modal: {
        size: 400,
        cssOverrides: {
            modalContent: css`
                padding: ${SPACING.standard};
            `,
            modalTitle: css`
                padding: 10px 10px 10px 20px;
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    breakQtyHeader: {
        ...headingStyles,
    },
    breakPriceHeader: {
        ...headingStyles,
    },
    savingsHeader: {
        ...headingStyles,
    },
});
